// Pricing knobs + workspace mailbox capacity for the purchase wizard
export const getZapmailPlan = () => ({
  type: 'GET_ZAPMAIL_PLAN'
});

// Domain availability search — results go to the callback (wizard-local state)
export const searchZapmailDomains = (data, successCallback, errorCallback) => ({
  payload: { data, successCallback, errorCallback },
  type: 'SEARCH_ZAPMAIL_DOMAINS',
});

// Load more suggested domains — next batch of generated variants (exclude = names already shown/checked)
export const loadMoreZapmailDomains = (data, successCallback, errorCallback) => ({
  payload: { data, successCallback, errorCallback },
  type: 'LOAD_MORE_ZAPMAIL_DOMAINS',
});

// Create order + redirect to Stripe hosted checkout
export const createZapmailCheckout = (data, errorCallback) => ({
  payload: { data, errorCallback },
  type: 'CREATE_ZAPMAIL_CHECKOUT',
});

// List this workspace's Zapmail orders
export const getZapmailOrders = () => ({
  type: 'GET_ZAPMAIL_ORDERS'
});

// Single order detail — polled by the provisioning card
export const getZapmailOrder = (orderId) => ({
  payload: { orderId },
  type: 'GET_ZAPMAIL_ORDER',
});

// Retry provisioning for a stuck order
export const retryZapmailOrder = (orderId, successCallback) => ({
  payload: { orderId, successCallback },
  type: 'RETRY_ZAPMAIL_ORDER',
});

// Cancel ALL of this user's unpaid orders in the workspace (chose "start new" over resuming)
export const cancelPendingZapmailOrders = (successCallback) => ({
  payload: { successCallback },
  type: 'CANCEL_PENDING_ZAPMAIL_ORDERS',
});

// List purchased domains
export const getZapmailDomains = () => ({
  type: 'GET_ZAPMAIL_DOMAINS'
});

// Renewal checkout for a purchased domain
export const renewZapmailDomain = (domainId, errorCallback) => ({
  payload: { domainId, errorCallback },
  type: 'RENEW_ZAPMAIL_DOMAIN',
});

// Save the workspace's shared purchase-wizard draft — stored as a 'draft'-status order; the whole
// team reads it back through getZapmailOrders (silent background save, id lands in the URL)
export const saveZapmailDraft = (data, successCallback) => ({
  payload: { data, successCallback },
  type: 'SAVE_ZAPMAIL_DRAFT',
});

// Discard the workspace's shared purchase-wizard draft
export const deleteZapmailDraft = (successCallback) => ({
  payload: { successCallback },
  type: 'DELETE_ZAPMAIL_DRAFT',
});

// ADMIN ONLY: wallet balance + provider cost estimate for the skip-payment button (callback only)
export const getZapmailAdminCostPreview = (data, successCallback) => ({
  payload: { data, successCallback },
  type: 'GET_ZAPMAIL_ADMIN_COST_PREVIEW',
});

// Mailbox credential reveal — delivered ONLY via callback, never stored in Redux
export const getZapmailMailboxCredentials = (integrationId, successCallback, errorCallback) => ({
  payload: { integrationId, successCallback, errorCallback },
  type: 'GET_ZAPMAIL_MAILBOX_CREDENTIALS',
});

// Update mailbox identity — formData carries firstName, lastName, removeProfilePicture, file
export const updateZapmailMailbox = (integrationId, formData, successCallback, errorCallback) => ({
  payload: { integrationId, formData, successCallback, errorCallback },
  type: 'UPDATE_ZAPMAIL_MAILBOX',
});
